// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__3O5-d","productName":"Table_productName__1cMH8"};